import React from "react";
import Sidebar, { SidebarSection } from "../components/Sidebar.tsx";
import { Outlet } from "react-router";

interface SidebarLayoutProps {
  sections: SidebarSection[];
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ sections }) => {
  return (
    <div className="relative flex w-full flex-1">
      <Sidebar sections={sections} />
      <main className="min-w-0 flex-1 overflow-x-hidden px-4 pt-4 pb-6">
        <Outlet />
      </main>
    </div>
  );
};

export default SidebarLayout;
